import React from "react";

const FodCodCashTabsComponentLoadable = React.lazy(() => import("./CashTabsComponent"));

export { FodCodCashTabsComponentLoadable };

